import { useTranslation } from "react-i18next";
import {
  type DealOutcomeView,
  formatOutcomeDate,
  outcomeLabel,
  outcomeStages,
  outcomeVariant,
} from "@/lib/dealOutcome";
import "./DealOutcomeSummary.css";

interface DealOutcomeSummaryProps {
  outcome: DealOutcomeView | null | undefined;
  /** Badge only (cards); the full stage list otherwise. */
  compact?: boolean;
}

/** Read-only deal outcome for companies (WP1.7): status + stage dates. */
const DealOutcomeSummary = ({ outcome, compact }: DealOutcomeSummaryProps) => {
  const { t } = useTranslation("components");
  if (!outcome) return null;
  const badge = (
    <span className={`deal-outcome__badge deal-outcome__badge--${outcomeVariant(outcome.status)}`}>
      {t("dealOutcome.badge", { status: outcomeLabel(outcome.status) })}
    </span>
  );
  if (compact) return badge;
  return (
    <div className="deal-outcome">
      <div className="deal-outcome__header">
        <span className="deal-outcome__title">{t("dealOutcome.progress")}</span>
        {badge}
      </div>
      <ol className="deal-outcome__stages">
        {outcomeStages(outcome).map((stage) => (
          <li key={stage.label} className={`deal-outcome__stage ${stage.date ? "deal-outcome__stage--done" : ""}`}>
            <span className="deal-outcome__stage-name">{stage.label}</span>
            <span className="deal-outcome__stage-date">{formatOutcomeDate(stage.date)}</span>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default DealOutcomeSummary;
